import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

function InfoField({ label, children }) {
  return (
    <div className="pagos-v2__info-field">
      <div><Text type="secondary">{label}</Text></div>
      <div>{children}</div>
    </div>
  );
}

export default function Informacion({ data }) {

  return (
    <div>
      <InfoField label="Reembolso ID"><Text strong>{data.reembolsoID}</Text></InfoField>
      <InfoField label="Asistencia"><Text strong>{data.asistenciaID}</Text></InfoField>
      <InfoField label="Solicitante"><Text strong>{data.usuarioNombreCreacion}</Text></InfoField>
      <InfoField label="Fecha"><Text strong>{data.fechaCreacion?.slice(0, 10)}</Text></InfoField>
      <InfoField label="Monto"><Text strong>${Number(data.monto).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</Text></InfoField>
      <InfoField label="Descripción"><Text strong>{data.descripcion}</Text></InfoField>
      <InfoField label="Motivo"><Text strong>{data.motivoReembolso}</Text></InfoField>
      <InfoField label="Usuario final"><Text strong>{data.nombreUsuarioFinalSolicita}</Text></InfoField>
      <InfoField label="Teléfono"><Text strong>{data.telefonoUsuarioFinalSolicita}</Text></InfoField>
      {data.motivoRechazo && (
        <InfoField label="Motivo rechazo"><Text strong>{data.motivoRechazo}</Text></InfoField>
      )}
    </div>
  );
}
